module.exports = __webpack_public_path__ + "static/img/img-conta.432fca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-conta.png
// module id = hPZq
// module chunks = 0